import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Total "inbox" count = unread DMs + incoming friend requests.
// Polls every 60s and refreshes when the tab regains focus.
export default function useInboxCount() {
  const { user } = useAuth();
  const [counts, setCounts] = useState({ dm: 0, requests: 0, total: 0 });

  useEffect(() => {
    if (!user) { setCounts({ dm: 0, requests: 0, total: 0 }); return; }
    let alive = true;
    const load = async () => {
      try {
        const [dmRes, frRes] = await Promise.all([
          api.get("/dm/unread-count").catch(() => ({ data: {} })),
          api.get("/friends/requests").catch(() => ({ data: {} })),
        ]);
        if (!alive) return;
        const dm = dmRes.data?.count ?? dmRes.data?.total ?? dmRes.data?.unread ?? 0;
        const requests = (frRes.data?.incoming || []).length;
        setCounts({ dm, requests, total: dm + requests });
      } catch (_) { /* noop */ }
    };
    load();
    const id = setInterval(load, 15000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    window.addEventListener("hw-inbox-refresh", onFocus);
    return () => {
      alive = false;
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
      window.removeEventListener("hw-inbox-refresh", onFocus);
    };
  }, [user]);

  return counts;
}
